import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  scheduleDatePicker: {
    maxWidth: 140,
    '& .MuiInputBase-input': {
      padding: '6px'
    }
  }
});
export default useStyles;